module.exports = __webpack_public_path__ + "static/media/icon-QC.35767ead.png";